import {makeDoubleDigitOther, checkApiDataResult} from '../../common/app_common'
import {getApiDataQueryRange} from '../../common/fetch_api/data';

const lineColor = ['#40DFFF','#F9C3FA','#B080FF','#00FF0E'];
let gQuery = '';

export function AnalyticChart(opt, setChartOptions, setAnalysisCondition, setAnalyticsResult, loading)
{
    let chartData = [[], [], [], []];

    const dataGathering = opt.gathering;
    const dateFrom = (Date.parse(opt.dateFrom) / 1000);
    const dateTo = Date.parse(opt.dateTo) / 1000;
    const category = parseInt(opt.category);
    const edgesInfo = opt.edges;
    const numberOfEdges = edgesInfo.length;
    
    let preStep = 1;

    for( let idx=0; idx<numberOfEdges; idx++ )
    {
        const edge = edgesInfo[idx];
        const query = [
            `dcs_system_usage_percent{type="cpu", id="${edge.edge}"}`,
            `dcs_system_usage_percent{type="mem", id="${edge.edge}"}`,
            `dcs_system_usage_percent{type="disk", id="${edge.edge}"}`,
            `dcs_out_bytes{id="${edge.edge}"}`,
            `dcs_fec_bytes{id="${edge.edge}"}`,
            `atsc3_stl_bytes{id="${edge.edge}"}`,
            `atsc3_stl_fec_bytes{id="${edge.edge}"}`,
            `atsc3_fec_overhead_percent{id="${edge.edge}"}`,
            `atsc3_tuner_rssi_dbm{id="${edge.edge}"}`,
            `atsc3_tuner_mer_db{id="${edge.edge}"}`,
            `atsc3_network_delay_ms{id="${edge.edge}"}`,
            `atsc3_mnd_ms{id="${edge.edge}"}`,
        ];

        gQuery = query[category];

        if( dataGathering === 'all' )
        {
            Promise.all( getAllChartApi(gQuery, dateTo, dateFrom) )
            .then( data =>
            {
                chartData[idx] = makePlotData(data, dateFrom, dateTo, dataGathering, preStep);

                if( numberOfEdges <= idx+1 )
                {
                    setTimeout(() => {
                        allChart(edgesInfo, chartData, dateFrom);
                        loading(false);
                    }, 500);
                }
            })
            .catch( e => {
                loading(false);
            });
        }
        else
        {
            preStep = Math.ceil((dateTo - dateFrom) / 3600);
            
            Promise.all( [getApiDataQueryRange(gQuery, dateFrom, dateTo, preStep)] )
            .then( data =>
            {
                chartData[idx] = makePlotData(data, dateFrom, dateTo, dataGathering, preStep);

                if( numberOfEdges <= idx+1 )
                {
                    setTimeout(() => {  //임시방편. 비동기처리를 어떻게 해야할까.....
                        samplingChart(edgesInfo, chartData, preStep);
                        loading(false);
                    }, 500);
                }
            })
            .catch( e => {
                loading(false);
            });
        }
    }

    function getAllChartApi(query, dateTo, dateFrom)
    {
        let apiArr = [];
        let start = dateFrom;
        let period = dateTo - start;
    
        while( period > 1800 )
        {
            apiArr.push( getApiDataQueryRange(query, start, start+1800, 1) );
    
            start += 1801;
            period = dateTo - start;
        }
    
        if( period > 0 )
        {
            apiArr.push( getApiDataQueryRange(query, start, dateTo, 1) );
        }
        
        return apiArr;
    }

    function samplingChartOption(queryData, unit, categoryLabel)
    {
        // create the chart
        let options = {
            chart: {
                zoomType: 'x',
                backgroundColor: 'transparent',
                margin: [0, 5, 10, 10],
            },
            credits: {
                enabled: false
            },
            boost: {
                useGPUTranslations: true,
            },
            // navigator: {
            //     adaptToUpdatedData: false,
            //     series: queryData
            // },
            scrollbar: {
                enabled: false,
            },
            rangeSelector: {
                buttons: [{
                    type: 'hour',
                    count: 0.5,
                    text: '30min'
                }, {
                    type: 'hour',
                    count: 1,
                    text: '1h'
                }, {
                    type: 'hour',
                    count: 2,
                    text: '2h'
                }, {
                    type: 'day',
                    count: 1,
                    text: '1d'
                }, {
                    type: 'all',
                    text: 'All'
                }],
                selected: 4,
                buttonSpacing: 0,
                buttonTheme: {
                    fill: 'none',
                    width : 36,
                    r: 4,
                    style: {
                        color: '#aab4c0',
                    },
                    states: {
                        hover: {
                            style: {
                                color: '#242424'
                            }
                        },
                        select: {
                            fill: '#515151',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                },
                inputEnabled: false
            },
            time: {
                useUTC: false,
            },
            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    },
                    lineWidth: 1,
                    showInNavigator: true
                }
            },
            xAxis: {
                lineColor: '#808080',
                type: 'datetime',
                events: {
                    afterSetExtremes: samplingAfterSetExtremes
                },
                minRange: 1800 * 1000 // half hour
            },
            yAxis: {
                // floor: 0,
                gridLineWidth: 0,
                opposite: false, //label 을 왼쪽으로
                min: 0,
                max: 100,
                showLastLabel: true,
                title: {
                    align: 'high',
                    offset: 10,
                    text: unit,
                    rotation: 0,
                    y: -15,
                    style: {
                        color: '#858582',
                        fontSize: 13,
                    },
                },
            },
            tooltip: {
                valueDecimals: 2,
                valueSuffix: unit,
                xDateFormat: '%Y-%m-%d %H:%M:%S',
            },
            series: queryData
    
        }
        return chartYaxisUnitLabel(options, categoryLabel, queryData, 'sampling');
    }

    function allChartOption(dataArray, unit, categoryLabel)
    {
        let options = {
            chart: {
                zoomType: 'x',
                backgroundColor: 'transparent',
                margin: [0, 5, 10, 10],
            },
            credits: {
                enabled: false
            },
            boost: {
                pixelRatio: 0,
                useGPUTranslations: true,
            },
            // navigator: {
            //     adaptToUpdatedData: false,
            //     series: queryData
            // },
            scrollbar: {
                enabled: false,
            },
            rangeSelector: {
                buttons: [{
                    type: 'hour',
                    count: 0.5,
                    text: '30min'
                }, {
                    type: 'hour',
                    count: 1,
                    text: '1h'
                }, {
                    type: 'hour',
                    count: 2,
                    text: '2h'
                }, {
                    type: 'all',
                    text: 'All'
                }],
                selected: 3,
                buttonSpacing: 0,
                buttonTheme: {
                    fill: 'none',
                    width : 36,
                    r: 4,
                    style: {
                        color: '#aab4c0',
                    },
                    states: {
                        hover: {
                            style: {
                                color: '#242424'
                            }
                        },
                        select: {
                            fill: '#515151',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                },
                inputEnabled: false
            },
            // legend: {
            //     enabled: true,
            //     layout: 'vertical',
            //     align: 'right',
            //     verticalAlign: 'top',
            //     y: -15,
            //     itemStyle: {
            //         color: '#858582',
            //     },
            //     itemHoverStyle: {
            //         color: '#d9d9d9'
            //     },
            //     itemHiddenStyle: {
            //         color: '#000'
            //     },
            //     symbolRadius: 0
            // },
            time: {
                useUTC: false,
            },
            plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    },
                    lineWidth: 1,
                    showInNavigator: true //series 갯수만큼 navigator 에도 보여줌
                }
            },
            xAxis: {
                lineColor: '#808080',
                type: 'datetime',
            },
            yAxis: {
                gridLineWidth: 0,
                opposite: false, //label 을 왼쪽으로
                min: 0,
                max: 100,
                showLastLabel: true,
                title: {
                    align: 'high',
                    offset: 10,
                    text: unit,
                    rotation: 0,
                    y: -15,
                    style: {
                        color: '#858582',
                        fontSize: 13,
                    },
                },
            },
            tooltip: {
                valueDecimals: 2,
                valueSuffix: unit,
                headerFormat: '<span style="font-size: 10px">{point.x:%Y-%m-%d %H:%M:%S}</span>',
            },
            series: dataArray
        }
    
        return chartYaxisUnitLabel(options, categoryLabel, dataArray, 'all');
    }

    function samplingAfterSetExtremes(event)
    {
        const { chart } = event.target;
        
        let min = (Math.round(event.min)) | 0;
        let max = (Math.round(event.max)) | 0;
        let diff = (Math.round(event.max) - Math.round(event.min));
        let step = Math.max(( diff / 3600 ) | 0, 1);
    
        chart.showLoading('Loading Data from server...');
    
        getApiDataQueryRange(gQuery, min, max, step)
        .then(data => {
            
            if( !checkApiDataResult(data) )
            {
                let queryData = [];
                for( const value of data.data.result[0].values )
                {
                    queryData.push( [value[0], parseFloat(value[1])] )
                }
    
                chart.series[0].setData(queryData);
                chart.hideLoading();
            }
            else
            {
                chart.hideLoading();
            }
        }).catch(error => console.error(error.message));
    }

    function allChart(edgeInfo, data, startTime)
    {
        if (data !== undefined)
        {
            let categoryInfo = categoryTypeUnit();
            let dataArray = [];
            let series;
            let edgeNames = [];
    
            for( let idx=0; idx<numberOfEdges; idx++)
            {
                const item = data[idx];
                let queryData = [];
    
                for( const value of item )
                {
                    queryData.push([value[0], parseFloat(value[1])]);
                }
    
                series = {
                    "name": edgeInfo[idx].name,
                    "pointStart":startTime * 1000,
                    "pointInterval":1000,
                    "dataLength":queryData.length,
                    "data": queryData,
                    "color": lineColor[idx],
                };
    
                edgeNames.push(edgeInfo[idx].name);
                dataArray.push(series);
            }
            
            setChartOptions(allChartOption(dataArray, categoryInfo.unit, categoryInfo.label));
            setAnalysisCondition({
                category: category,
                gathering: dataGathering,
                from: dateFrom,
                to: dateTo,
                edges: edgesInfo,
                data: dataArray
            });
            chartInfoList(data, categoryInfo.unit, edgeNames);
        }
    }

    function samplingChart(edgeInfo, data, preStep)
    {
        if (data !== undefined)
        {
            let categoryInfo = categoryTypeUnit();
            let dataArray = [];
            let series;
            let edgeNames = [];
    
            for( let idx=0; idx<numberOfEdges; idx++)
            {
                const item = data[idx];
                let queryData = [];

                for( const value of item )
                {
                    queryData.push([value[0], parseFloat(value[1])]);
                }
                
                series = {
                    'gapSize': preStep,
                    'name': edgeInfo[idx].name,
                    'data': queryData,
                    'color': lineColor[idx],
                    'dataGrouping': {enabled: false}
                }
                
                edgeNames.push(edgeInfo[idx].name);
                dataArray.push(series);
            }
            
            setChartOptions(samplingChartOption(dataArray, categoryInfo.unit, categoryInfo.label));
            setAnalysisCondition({
                category: category,
                gathering: dataGathering,
                from: dateFrom,
                to: dateTo,
                edges: edgesInfo,
                data: dataArray
            });
            chartInfoList(data, categoryInfo.unit, edgeNames);
        }
    }

    function chartYaxisUnitLabel(options, categoryLabel, dataArray, gatheringType)
    {
        switch (categoryLabel) {
            case "STL":
            case "FEC":
                for( let idx=0; idx<dataArray.length; idx++)
                {
                    const item = dataArray[idx];
                    let checkZeroValue = item.data.every((x) =>
                    {
                        if(gatheringType === 'sampling')
                        {
                            if (x[1] === 0) {
                                return true;
                            }
                            return false;
                        }
                        else
                        {
                            if (x === 0) {
                                return true;
                            }
                            return false;
                        }
                    })
            
                    if ( idx < 1 && checkZeroValue )  //device 가 한개이면서 zero 일때
                    {
                        options.yAxis.max = 100;
                    }
                    else
                    {
                        options.yAxis.max = null;
                    }
                }
                break;
            case "Overhead":
                options.yAxis.max = 100;
                break;
            case "RSSI":
                options.yAxis.min = -99;
                options.yAxis.max = 0;
                break;
            case "MER":
                options.yAxis.min = 0;
                options.yAxis.max = 40;
                break;
            case "Network Delay":
            case "MND":
                options.yAxis.min = 0;
                options.yAxis.max = 1000;
                break;
        }
        return options;
    }

    function categoryTypeUnit()
    {
        let result = {type: '', unit: '', label: ''};

        switch (category)
        {
            case 0:
                result = {type: '', unit: '%', label: 'CPU'};
                break;
            case 1:
                result = {type: '', unit: '%', label: 'MEM'};
                break;
            case 2:
                result = {type: '', unit: '%', label: 'DISK'};
                break;
            case 3:
                result = {type: 'bytesType', unit: 'Mbps', label: 'STL'};
                break;
            case 4:
                result = {type: 'bytesType', unit: 'Mbps', label: 'FEC'};
                break;
            case 5:
                result = {type: 'bytesType', unit: 'Mbps', label: 'STL'};
                break;
            case 6:
                result = {type: 'bytesType', unit: 'Mbps', label: 'FEC'};
                break;
            case 7:
                result = {type: '', unit: '%', label: 'Overhead'};
                break;
            case 8:
                result = {type: '', unit: 'dBm', label: 'RSSI'};
                break;
            case 9:
                result = {type: '', unit: 'dB', label: 'MER'};
                break;
            case 10:
                result = {type: '', unit: 'ms', label: 'Network Delay'};
                break;
            case 11:
                result = {type: '', unit: 'ms', label: 'MND'};
                break;
            default:break;
        }

        return result;
    }

    function makePlotData(data, dateFrom, dateTo, dataGathering, preStep)
    {
        const millsTo = dateTo * 1000;

        let mergeData = [];
        let end = 0;
        let pre = dateFrom * 1000;
        
        for(let item of data)
        {
            let step = preStep * 1000;
            let result = null;
            let checkData = [];
    
            if( item.data.result[0] )
            {
                result = item.data.result[0];
            }
    
            if( dataGathering === 'all' )
            {
                end = pre + 1800000;
    
                if( end > millsTo )
                {
                    end = millsTo;
                }
            }
            else
            {
                end = millsTo;
            }
        
            if(result && result.values)
            {
                for (let value of result.values )
                {
                    let addData = Number(value[1]);
                    let timeLabel = value[0] * 1000;
            
                    if ( categoryTypeUnit().type === 'bytesType' )
                    {
                        addData = Number(value[1]) * 8 / 1000000;
                    }
                    
                    //이전 timestamp와 현재 timestamp 간격만큼 null추가
                    for(let idx = pre+step; idx < timeLabel; idx += step )
                    {
                        checkData.push([idx, null]);
                    }
        
                    pre = timeLabel;
                    checkData.push([timeLabel, addData]);
                }
            }
    
            //마지막으로 push한 timapstamp와 해당 데이터 구간의 마지막 timestamp까지의 간격에 빈칸이 있을때 null로 채움
            while((end-pre) >= step )
            {
                checkData.push([pre, null]);
                pre += step;
            }
            
            mergeData = mergeData.concat(checkData);
        }
    
        return mergeData;
    }

    function getMaxDateValue(data)
    {
        let maxValue = data[0][1];
        let maxTime;
        for (let i = 0; i < data.length; i++)
        {
            if (maxValue < data[i][1])
            {
                maxValue = data[i][1];
                maxTime = data[i][0]
            }
        }

        return {
            maxValue: maxValue,
            maxTime: maxTime
        }
    }

    function getMinDateValue(data)
    {
        let minValue = data[0][1];
        let minTime = data[0][0];;

        if( minValue === null )
        {
            minValue = 0;
        }

        for (let i = 0; i < data.length; i++)
        {
            if( data[i][1] !== null )
            {
                if (minValue > data[i][1])
                {
                    minValue = data[i][1];
                    minTime = data[i][0]
                }
            }
        }

        return {
            minValue: minValue,
            minTime: minTime
        }
    }

    function getAverageValue(data)
    {
        let sum = 0;
        
        for (let i = 0; i < data.length; i++)
        {
            sum += data[i][1];
        }
        return sum / data.length;
    }

    function commas(num)
    { 
        let parts = num.toString().split("."); 
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : ""); 
    }

    function timestampToDate(timestamp)
    {
        let time = new Date(timestamp);

        let year = String(time.getFullYear());

        let month = makeDoubleDigitOther(time.getMonth()+1);
        let date = makeDoubleDigitOther(time.getDate());

        let hours = makeDoubleDigitOther(time.getHours());
        let minutes = makeDoubleDigitOther(time.getMinutes());
        let seconds = makeDoubleDigitOther(time.getSeconds());

        return `${date}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    
    function chartInfoList(data, unit, edgeNames)
    {
        let result = [];
        const size = data.length;
        for( let idx=0; idx<size; idx++)
        {
            const item = data[idx];

            let maxTime;
            let minTime;
            let maxValue;
            let minValue;
            let averageValue;

            let zeroValue = item.every((x) => {
                if (x[1] === 0) {
                    return true;
                }
                return false;
            })

            let sameValue = item.every((x) => {
                if (x[1] === item[0][1]) {
                    return true;
                }
                return false;
            })

            let nullValue = item.every((x) => {
                if (x[1] === null) {
                    return true;
                }
                return false;
            })

            let maxT = opt.dateTo;
            let minT = opt.dateFrom;

            if( nullValue )
            {
                maxTime = "--/--/-- --:--:--";
                minTime = "--/--/-- --:--:--";
                maxValue = '-';
                minValue = '-';
                averageValue = '-';
            }
            else if( item.length === 0 || zeroValue === true )
            {
                maxTime = timestampToDate(maxT);
                minTime = timestampToDate(minT);
                maxValue = '0.00';
                minValue = '0.00';
                averageValue = '0.00';
            }
            else if( sameValue )
            {
                maxTime = timestampToDate(maxT);
                minTime = timestampToDate(minT);

                maxValue = item[0][1].toFixed(2);
                minValue = item[0][1].toFixed(2);
                averageValue = item[0][1].toFixed(2);
            }
            else
            {
                let max = getMaxDateValue(item);
                let min = getMinDateValue(item);

                maxTime = timestampToDate(max.maxTime);
                minTime = timestampToDate(min.minTime);
                maxValue = max.maxValue.toFixed(2);
                minValue = min.minValue.toFixed(2);
                averageValue = (getAverageValue(item)).toFixed(2);
            }

            result[edgeNames[idx]] = {
                maxTime: maxTime,
                maxValue: `${maxValue}${unit}`,
                minTime: minTime,
                minValue: `${minValue}${unit}`,
                avr: `${averageValue}${unit}`,
                count: String(commas(item.length))
            };
        }

        setAnalyticsResult(result);
    }
}